import { ModalTemplate } from '@/ui'
import styles from './ProfUnions.module.scss'
import { ProfUnionsForm } from '@/entity/profUnions/ui/form'
import { initialProfUnions } from '@/entity/profUnions/model/reducer'
import { useDispatch, useSelector } from 'react-redux'
import { profUnionsActions, profUnionsSelectors, profUnionsThunks, userSelectors } from '@/entity'
import { handbookSelectors } from '@/entity/handbook'
import { useMemo, useEffect } from 'react'
import { useDigitalSign } from '@/shared'

export const ProfUnions = ({ onCancel, actions, activeCompany, cabinetTradeUnion, tradeUnion }) => {
	const dispatch = useDispatch()
	const unionType = useSelector(handbookSelectors.unionType)
	const okedsTop = useSelector(handbookSelectors.okedsTop)
	const districts = useSelector(handbookSelectors.districts)

	const options = useMemo(() => ({
		unionType,
		okedsTop,
		districts,
	}), [unionType, okedsTop, districts])
	const profUnionXml = useSelector(profUnionsSelectors.xml)
	const isSuccess = useSelector(profUnionsSelectors.isSuccess)
	const isEmployee = useSelector(userSelectors.activeRole) === 'ROLE_EMPLOYEE'
	const { successPayload, onSign, failedPayload, onClearPayload } = useDigitalSign()

	const onClear = () => {
		onClearPayload()
		dispatch(profUnionsActions.resetXml())
		dispatch(profUnionsActions.toggleSuccess(false))
		if (isSuccess) {
			dispatch(profUnionsActions.reset())
			onCancel()
		}
	}

	let profUnions
	if (actions.edit) {
		profUnions = tradeUnion
	} else if (!isEmployee) {
		profUnions = cabinetTradeUnion ?
			{ ...initialProfUnions, bin: activeCompany?.bin, unionName: activeCompany?.companyName }
			: { ...initialProfUnions, parents: [{parentBin: activeCompany?.bin, parentName: activeCompany?.companyName}] }
	} else {
		profUnions = initialProfUnions
	}


	const onSubmit = (data) => {
		dispatch(profUnionsThunks.getXml(data))
	}

	useEffect(() => profUnionXml && onSign(profUnionXml), [profUnionXml])

	useEffect(() => {
		if (successPayload) {
			dispatch(profUnionsThunks.sendSignedProfUnions(successPayload, isEmployee, cabinetTradeUnion))
			onClear()
		}
	}, [successPayload])


	return (
		<ModalTemplate onClose={onCancel}>
			<div className={`scroll ${styles.wrapper}`}>
				<ProfUnionsForm
					initialValues={profUnions}
					options={options}
					onCancel={onCancel}
					onSubmit={onSubmit}
					actions={actions}
					cabinetTradeUnion={cabinetTradeUnion}
				></ProfUnionsForm>
			</div>
		</ModalTemplate>
	)
}
